module.exports = __webpack_public_path__ + "media/images/admin/icons/copy-4c19a6dd8558a8e82f16d174837df176.svg";